import React from "react";
import { motion } from "framer-motion";
import SectionTitle from "./SectionTitle";
import { eduExp } from "../content/home";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.55, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] } }),
};

const EduExp = () => {
  return (
    <section id="deneyim" className="relative scroll-mt-24 py-24">
      <div className="mx-auto max-w-7xl container-px">
        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }} className="section-eyebrow mb-4">
          <span className="h-px w-8 bg-brand-500" /> {eduExp.eyebrow}
        </motion.div>
        <motion.div variants={fadeUp} custom={1} initial="hidden" whileInView="show" viewport={{ once: true }}>
          <SectionTitle lead={eduExp.title.lead} accent={eduExp.title.accent} tail={eduExp.title.tail} className="max-w-3xl" />
        </motion.div>

        <div className="mt-12 grid gap-12 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <h3 className="mb-6 font-display text-sm font-semibold uppercase tracking-[0.25em] text-gray-500 dark:text-white/40">
              {eduExp.experienceHeading}
            </h3>
            <ol className="relative space-y-4 before:absolute before:left-3 before:top-2 before:bottom-2 before:w-px before:bg-gradient-to-b before:from-brand/60 before:via-gray-300 before:to-transparent dark:before:via-white/10">
              {eduExp.experience.map((e, i) => (
                <motion.li
                  key={`${e.company}-${e.period}`}
                  variants={fadeUp}
                  custom={i}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true, margin: "-60px" }}
                  className="relative pl-10"
                >
                  <span className="absolute left-0 top-4 grid h-6 w-6 place-items-center rounded-full border border-black/15 bg-white dark:border-white/15 dark:bg-ink-700">
                    <span className="h-2 w-2 rounded-full bg-gradient-to-r from-brand to-flame" />
                  </span>
                  <div className="glass-card group p-5 transition-colors hover:border-black/20 dark:hover:border-white/20">
                    <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
                      <h4 className="font-display text-lg font-semibold text-gray-900 dark:text-white">{e.role}</h4>
                      <span className="font-mono text-xs text-brand-500">{e.period}</span>
                    </div>
                    <div className="mb-3 text-sm text-gray-600 dark:text-white/60">{e.company}</div>
                    <ul className="space-y-2 text-sm text-gray-600 dark:text-white/55">
                      {e.points.map((p, j) => (
                        <li key={j} className="flex gap-2">
                          <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-flame" />
                          <span>{p}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </motion.li>
              ))}
            </ol>
          </div>

          <div>
            <h3 className="mb-6 font-display text-sm font-semibold uppercase tracking-[0.25em] text-gray-500 dark:text-white/40">
              {eduExp.educationHeading}
            </h3>
            <div className="space-y-4">
              {eduExp.education.map((e, i) => (
                <motion.div
                  key={e.degree}
                  variants={fadeUp}
                  custom={i}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true }}
                  className="glass-card p-6"
                >
                  <div className="mb-3 grid h-10 w-10 place-items-center rounded-xl border border-black/10 bg-black/[0.04] text-flame dark:border-white/10 dark:bg-white/[0.03]">
                    <svg viewBox="0 0 448 512" className="h-5 w-5" fill="currentColor">
                      <path d="M219.3 .5c3.1-.6 6.3-.6 9.4 0l200 40C439.9 42.7 448 52.6 448 64s-8.1 21.3-19.3 23.5L352 102.9V160c0 70.7-57.3 128-128 128s-128-57.3-128-128V102.9L48 93.3v65.1l15.7 78.4c.9 4.7-.3 9.6-3.3 13.3s-7.6 5.9-12.4 5.9H16c-4.8 0-9.3-2.1-12.4-5.9s-4.3-8.6-3.3-13.3L16 158.4V86.6C6.5 83.3 0 74.3 0 64C0 52.6 8.1 42.7 19.3 40.5l200-40z" />
                    </svg>
                  </div>
                  <h4 className="font-display text-base font-semibold text-gray-900 dark:text-white">{e.degree}</h4>
                  <div className="text-sm text-gray-600 dark:text-white/60">{e.school}</div>
                  <div className="mt-1 font-mono text-xs text-brand-500">{e.period}</div>
                  <p className="mt-2 text-sm text-gray-500 dark:text-white/50">{e.detail}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EduExp;